<template>
  <tabs class="order-details-tabs">
    <tab title="Products">
      <div class="p-4">
        <OrderProductTable
          v-if="order.details"
          :details="order.details"
        />
      </div>
    </tab>

    <tab title="Tracking">
      <div class="p-4">
        <OrderTrackingTable />
      </div>
    </tab>

    <tab title="Totals">
      <OrderShopifyTotals :order="order" />
    </tab>
  </tabs>
</template>

<script>
import Tab from "@/components/elements/Tab.vue";
import Tabs from "@/components/elements/Tabs.vue";
import OrderProductTable from "./OrderProductTable.vue";
import OrderTrackingTable from "./OrderTrackingTable.vue";
import OrderShopifyTotals from "./OrderShopifyTotals.vue";

export default {
  name: "OrderDetails",
  components: {
    Tab,
    Tabs,
    OrderProductTable,
    OrderTrackingTable,
    OrderShopifyTotals
  },
  props: {
    order: {
      type: Object,
      required: true
    },
  },
  data() {
    return {};
  },
  created() {
    // Shared by the Totals tab and the Products table Price column
    if (this.order.SourceOrderNumber) {
      this.$store.dispatch("orders/fetchShopifyOrder", this.order.SourceOrderNumber);
    }
  }
};
</script>

<style scoped>
/* The card doesn't clip its content (so Actions menus can drop below short tables),
   so the tab header rounds its own top corners to match the card */
.order-details-tabs ::v-deep > ul {
  @apply rounded-t-lg;
}
</style>
